"use strict";
const React = require('react');
const Dialog_1 = require('material-ui/Dialog');
const FlatButton_1 = require('material-ui/FlatButton');
const TextField_1 = require('material-ui/TextField');
const ERROR_BLANK_NAME = 'A task name is required.';
class AddTaskDialog extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = (e) => {
            e.preventDefault();
            const name = this.refs.taskName.getValue();
            if (!name) {
                this.setState({ errorText: ERROR_BLANK_NAME });
                return;
            }
            this.props.onSubmit(name);
        };
        this.state = {
            errorText: '',
        };
    }
    render() {
        const actions = [
            React.createElement(FlatButton_1.default, {label: "Cancel", onTouchTap: this.props.onRequestClose}),
            React.createElement(FlatButton_1.default, {label: "Add Task", primary: true, keyboardFocused: false, onTouchTap: this.handleSubmit}),
        ];
        return (React.createElement(Dialog_1.default, {title: "Add a task", actions: actions, open: this.props.isOpen, onRequestClose: this.props.onRequestClose}, 
            React.createElement("form", {onSubmit: this.handleSubmit}, 
                React.createElement(TextField_1.default, {ref: "taskName", hintText: "Task name", errorText: this.state.errorText, style: style.textField})
            )
        ));
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AddTaskDialog;
const style = {
    textField: {
        maxWidth: '100%',
    },
};



/** WEBPACK FOOTER **
 ** ./src/components/AddTaskDialog.tsx
 **/